<button mat-fab *ngIf="deferredInstallPrompt" [loading]="installingPWA" (click)="install()" color="warn" aria-label="Install app">
    <mat-icon>save_alt</mat-icon>
</button>
<button type="button" aria-label="Update app" mat-raised-button color="warn" *ngIf="pwaService.updateAvailable$ | async"
    (click)="update()">
    <mat-icon>refresh</mat-icon>Update
</button>
